if (!customElements.get('wls-pagination')) {
  class WLSNPagination extends HTMLElement {
    constructor() {
      super();
      this.onClick = this._onClick.bind(this);
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    /**
     * Handle click event on pagination links
     * @param {Event} event - The click event
     * @returns {void}
     */
    _onClick(event) {
      if (!this.hasAttribute('ajax')) return;

      const link = event.target.closest('a[data-page]');
      if (!link) return;

      event.preventDefault();

      const url = new URL(window.location.href);
      url.searchParams.set('page', link.dataset.page);

      this.dispatchEvent(
        new CustomEvent('wls:pagination:page-changed', {
          bubbles: true,
          detail: { url: url.toString() },
        }),
      );
    }
  }

  customElements.define('wls-pagination', WLSNPagination);
}
